var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('en-shortcut'),_vm._v(" "),_c('en-header'),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('router-view',{on:{"dd":_vm.dd}})],1),_vm._v(" "),_c('en-footer'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"scrollBox",on:{"click":_vm.scrollToTop}},[_vm._v("顶部 "),_c('i',{staticClass:"el-icon-arrow-up"})])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23679197","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/default.vue
// module id = null
// module chunks = 